import React, { createContext, useContext, useState } from 'react';

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]); 

  const showNotification = (message, type = 'info', id = Date.now(), duration = 5500) => {
    const exists = notifications.some((notification) => notification.id === id);
    if (exists) {
      return; 
    }
    
    setNotifications((prev) => [...prev, { id, message, type }]);

    setTimeout(() => {
      removeNotification(id);
    }, duration);
  };

  const removeNotification = (id) => {
    setNotifications((prev) => prev.filter((notification) => notification.id !== id));
  };

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}

      {notifications.length>0&& (
        <div className="notification-container">
          {notifications.map((notification) => (
            <div
              key={notification.id}
              className={`notification ${notification.type}`}
              onAnimationEnd={(e) => {
                if (e.animationName === 'fade-out') {
                  removeNotification(notification.id);
                }
              }}
            >
              {notification.message}
              <button
                className="close-btn"
                onClick={() => removeNotification(notification.id,'info',)}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}
    </NotificationContext.Provider>
  );
};